import { api } from "@/api";

export interface PostLoginResponse {
  success: boolean;
}

export async function postLoginUser(): Promise<PostLoginResponse> {
  const res = await api.postLogin();
  return res as PostLoginResponse;
}

export async function postLogoutUser(): Promise<PostLoginResponse> {
  const res = await api.postLogout();
  return res as PostLoginResponse;
}

export async function getFluxxUserId(userPrincipalName: string): Promise<string> {
  const res = await api.getFluxxUserId(userPrincipalName);
  return res as string;
}

export async function postUserRoleSwitch( role: string) {
  const res = await api.postRoleSwitch(role);
  return res;
}
